<template>
    <div class="icoGroup">
        <ui-IcoBtn :sizeLg="true" :valueIco="valueIco" :active="active || actives.length > 0" @click="$emit('click')">
        </ui-IcoBtn>
        <div class="icoGroup__group" v-for="(group, igroup) in groups" :key="group.key">
            <label>{{ group.key }}</label>
            <div class="icoGroup__groupIcos">
                <template v-for="(value, ivalue) in group.values">
                    <ui-IcoBtn
                        :key="ivalue"
                        :valueText="value"
                        :active="isActive(igroup, ivalue)"
                        @click="$emit('itemClick', { group: igroup, value: ivalue })"
                    >
                    </ui-IcoBtn>
                </template>
            </div>
        </div>
        <div class="icoGroup__group" :class="{ 'icoGroup__group--visible': groupInfo }" v-if="groupInfo">
            <div class="icoGroup__groupInfo" :class="{ 'ico--active': activeInfo }">
                <i>{{ groupInfo }}</i>
            </div>
        </div>
        <label>{{ name }}</label>
    </div>
</template>

<script>
    import ui_IcoBtn from './ui-IcoBtn.vue';

    export default {
        components: { ui_IcoBtn },
        name: 'ui-IcoGroup',
        props: {
            valueIco: String,
            name: String,
            groupInfo: String,
            active: {
                type: Boolean,
                default: false,
            },
            activeInfo: {
                type: Boolean,
                default: false,
            },
            actives: Array,
            groups: Array,
        },
        methods: {
            isActive: function(igroup, ivalue) {
                return this.actives.some((x) => {
                    if (x.group && x.value) return x.group == igroup && x.value == ivalue;
                    else return x == ivalue;
                });
            },
            modeLabel: function() {
                return this.isModeHeat() ? 'calor' : 'frio';
            },
            modeIcoTarget: function() {
                return this.isModeHeat() ? 'mode-heat' : 'mode-cool';
            },
        },
    };
</script>
